<template>
  <div>
    <div v-if="editable && showAddInput" class="mt-4">
      <div class="text-input-label">Add New Day</div>
      <div class="d-flex align-center" style="gap: 12px">
        <v-menu
          v-model="newDateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="formatDate(newDate)"
              readonly
              v-bind="attrs"
              v-on="on"
              solo
              flat
              dense
              hide-details
              background-color="#F6F6F6"
              placeholder="dd.mm.yyyy"
              append-icon="mdi-calendar"
              class="pkmn-input add-new-day-input"
            />
          </template>
          <v-date-picker
            :value="newDate"
            @input="onNewDateChange"
            no-title
            color="primary"
            :first-day-of-week="1"
          />
        </v-menu>
        <v-btn
          class="pkmn-button add-day-button"
          outlined
          color="primary"
          :disabled="!newDate || isNewDateDuplicate"
          @click="addNewDay"
        >
          Add Day
        </v-btn>
      </div>
    </div>
    <div class="d-flex align-center mt-4 mb-2">
      <div class="text-input-label mb-0">Date</div>
      <v-spacer />
      <v-btn
        v-if="editable && !showAddInput"
        icon
        color="primary"
        @click="showAddInput = true"
      >
        <v-icon>mdi-plus-circle</v-icon>
      </v-btn>
    </div>
    <div
      v-for="(item, index) in items"
      :key="index"
      class="holiday-date-row d-flex align-center"
      :class="{ 'holiday-date-row--alt': index % 2 === 0 }"
    >
      <span class="holiday-date-text">{{ formatDate(item.holiday_date) }}</span>
      <v-spacer />
      <v-btn
        v-if="editable"
        class="pkmn-button pkmn-button--no-padding data__action-button holiday-date-row__delete"
        text
        color="warning"
        @click="removeRow(index)"
      >
        <img src="@/assets/button-delete.svg" />
      </v-btn>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DataTableHolidays',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      items: [],
      showAddInput: false,
      newDate: null,
      newDateMenu: false
    }
  },
  computed: {
    isNewDateDuplicate() {
      if (!this.newDate) return false
      return this.items.some((i) => i.holiday_date === this.newDate)
    }
  },
  watch: {
    data: {
      handler(val) {
        this.items = (val || []).map((h) => ({
          holiday_date_id: h.holiday_date_id ?? null,
          holiday_date: h.holiday_date ?? null
        }))
      },
      immediate: true
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return ''
      return moment(date, 'YYYY-MM-DD').format('DD.MM.YYYY')
    },
    onNewDateChange(isoDate) {
      this.newDate = isoDate
      this.newDateMenu = false
    },
    addNewDay() {
      if (!this.newDate || this.isNewDateDuplicate) return
      this.items.push({
        holiday_date_id: null,
        holiday_date: this.newDate
      })
      this.newDate = null
      this.onItemChange()
    },
    removeRow(index) {
      this.items.splice(index, 1)
      this.onItemChange()
    },
    onItemChange() {
      this.$emit(
        'update',
        this.items.map((item) => ({
          holiday_date_id: item.holiday_date_id,
          holiday_date: item.holiday_date
        }))
      )
    },
    isValid() {
      if (this.items.length === 0) return false
      const dates = this.items.map((i) => i.holiday_date)
      if (dates.some((d) => !d)) return false
      return new Set(dates).size === dates.length
    }
  }
}
</script>

<style lang="scss" scoped>
.holiday-date-row {
  padding: 0 12px;
  border-radius: 4px;
  height: 48px;
}

.holiday-date-row--alt {
  background-color: #f6f6f6;
}

.holiday-date-text {
  font-size: 14px;
}

.add-new-day-input {
  flex: 1;
}

.add-day-button.v-btn {
  height: 31px !important;
  min-width: 87px !important;
  border-radius: 4px !important;
  padding: 0 16px !important;

  &.v-btn--outlined {
    border-width: 1px !important;
  }

  ::v-deep .v-btn__content {
    font-size: 10px;
    font-weight: 600;
    line-height: 15px;
    letter-spacing: 0;
    text-transform: none;
  }
}

.holiday-date-row__delete {
  opacity: 0 !important;
  transition: opacity 0.15s ease;
  pointer-events: none;
}

.holiday-date-row:hover .holiday-date-row__delete {
  opacity: 1 !important;
  pointer-events: auto;
}
</style>
